module.exports = __webpack_public_path__ + "img/2.1093e62d.jpg";